<template>
  <div class="overview">
    <component v-bind:is="myComponent"></component>
  </div>
</template>

<script>
import monitorInfo from "../components/monitor/info";
import monitorIndex from "../components/monitor/index";
export default {
  name: "overview",
  data() {
    return {
      myComponent: "monitorInfo",
    };
  },
  components: { monitorInfo, monitorIndex },
  created() {},
};
</script>

<style lang="less" scoped>
.overview {
  background-color: #eceef3;
  height: 100%;
}
</style>